import {InjectionToken} from '@angular/core';

export const EMAIL_SUPPORT = new InjectionToken<string>('EMAIL_SUPPORT');
export const ENDPOINT_PAGE_TERMS = new InjectionToken<string | null>('ENDPOINT_PAGE_TERMS');
export const ENDPOINT_PAGE_PRIVACY_POLICY = new InjectionToken<string | null>('ENDPOINT_PAGE_PRIVACY_POLICY');
export const ENDPOINT_PAGE_COOKIES = new InjectionToken<string | null>('ENDPOINT_PAGE_COOKIES');
export const ENDPOINT_BASE_SITE = new InjectionToken<string | null>('ENDPOINT_BASE_SITE');
export const PASSWORD_MIN_LENGTH = new InjectionToken<number>('PASSWORD_MIN_LENGTH', {
  factory: () => 8,
});
export const PASSWORD_MAX_LENGTH = new InjectionToken<number>('PASSWORD_MIN_LENGTH', {
  factory: () => 200,
});

export const GOOGLE_CLIENT_ID = new InjectionToken<string | null>('GOOGLE_CLIENT_ID');

export const GOOGLE_MAP_API_KEY = new InjectionToken<string | null>('GOOGLE_MAP_API_KEY');
